var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14a1.5 1.5 0 001.5-1.5v-9A1.5 1.5 0 0014.5 2h-13A1.5 1.5 0 000 3.5v9A1.5 1.5 0 001.5 14h13zm-.188-1.5H1.687a.188.188 0 01-.187-.188V3.687c0-.103.084-.187.187-.187h12.625c.104 0 .188.084.188.187v8.625a.188.188 0 01-.188.188zM4 7.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM13 11V8.5l-2.735-2.735a.375.375 0 00-.53 0L6 9.5 4.765 8.265a.375.375 0 00-.53 0L3 9.5V11h10z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/242e58baf955e6162f3042f503a94012-image.svg";
export { SvgImage as ReactComponent };